import React from "react";

const Maintenance = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>🚧 Site Under Maintenance</h1>
      <p style={styles.message}>
        We're currently making some updates. Please check back later.
      </p>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    color: "#333",
    fontFamily: "sans-serif",
  },
  heading: {
    fontSize: "2.5rem",
    marginBottom: "1rem",
  },
  message: {
    fontSize: "1.2rem",
    textAlign: "center",
    maxWidth: "400px",
  },
};

export default Maintenance;
